import { AgentActionType } from 'entities/AgentActions'
import {
  type IAgentActionItem,
  type IAgentActionsConfig,
  ActionNote,
  makeActionTags,
} from 'widgets/AgentActions'

export const SUCCESS_ACTION_ITEMS: IAgentActionItem[] = [
  { id: AgentActionType.AddTag, label: 'Add tag', iconL: 'tag' },
  { id: AgentActionType.RemoveTag, label: 'Remove tag', iconL: 'tagRemove' },
  { id: AgentActionType.ContactNote, label: 'Add contact note', iconL: 'edit' },
]

export const SUCCESS_ACTIONS_CONFIG: IAgentActionsConfig = {
  [AgentActionType.AddTag]: {
    icon: 'tag',
    title: 'Add tag',
    Component: makeActionTags({ canCreate: true, placeholder: 'Search or create' }),
  },
  [AgentActionType.RemoveTag]: {
    icon: 'tagRemove',
    title: 'Remove tag',
    Component: makeActionTags({ canCreate: false, placeholder: 'Search' }),
  },
  [AgentActionType.ContactNote]: {
    icon: 'edit',
    title: 'Contact note',
    Component: ActionNote,
  },
}
